export default "__VITE_PUBLIC_ASSET__1ab65378__"